import {
  WSDivider,
  WSGrid,
  WSInfoBox,
  WSList
} from "@wingspanhq/fe-component-library";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { queriesCards } from "@query";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { PayoutSplits } from "../../Settings/components/PayoutSplits";
import { WingspanAccounts } from "../../Settings/components/WingspanAccounts";
import { AvailableBalance } from "../components/AvailableBalance";
import { BankCardsList } from "../components/BankCardsList/BankCardsList";
import { CardholderBenefits } from "../components/CardholderBenefits";
import { CashbackBalance } from "../components/CashbackBalance";
import { CashbackProgramWidget } from "../components/DebitCashbackProgram";
import { useModalAddCardToDigitalWallet } from "../modals/ModalAddCardToDigitalWallet";
import { useModalUpdateWalletDepositRate } from "../modals/ModalUpdateWalletDepositRate";

export const RouteDashboard: React.FC = () => {
  const featureFlags = useFeatureFlags();
  const modalUpdateWalletDepositRate = useModalUpdateWalletDepositRate();
  const modalAddCardToDigitalWallet = useModalAddCardToDigitalWallet();
  const queryCards = queriesCards.listCards.useQuery();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.search.includes("digital-wallet-instructions")) {
      modalAddCardToDigitalWallet.open({
        onClose: () => history.replace({ search: "" })
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <WSGrid gutter={{ s: "3XL" }}>
      <WSGrid.Item span={{ m: "8" }}>
        <WSGrid mb="4XL">
          <WSGrid.Item
            span={{ m: "12", l: featureFlags.data?.cashback2025 ? "6" : "12" }}
          >
            <AvailableBalance />
          </WSGrid.Item>
          {featureFlags.data?.cashback2025 ? (
            <WSGrid.Item span={{ m: "12", l: "6" }}>
              <CashbackBalance />
            </WSGrid.Item>
          ) : null}
        </WSGrid>
        <BankCardsList />
      </WSGrid.Item>
      <WSGrid.Item span={{ m: "4" }}>
        <WSList gap="2XL">
          {!!queryCards.data?.data?.length && (
            <WSInfoBox>
              <b>Enjoy secure, contactless payments on-the-go!</b> Add your
              Wingspan card to a digital wallet.{" "}
              <a onClick={() => modalAddCardToDigitalWallet.open()}>
                Learn how
              </a>
            </WSInfoBox>
          )}
          {featureFlags.data?.cashback2025 ? <CardholderBenefits /> : null}
          <PayoutSplits
            onEditWallet={() => modalUpdateWalletDepositRate.open()}
          />
          <WSDivider />
          <WingspanAccounts accountType={"Banking"} />
          {/*<WSButton.Link rightIcon="chevron-right">Search for ATMs</WSButton.Link>*/}
          {featureFlags.data?.cashback2025 ? <CashbackProgramWidget /> : null}
        </WSList>
      </WSGrid.Item>
    </WSGrid>
  );
};
